<template>
  <div class="choice-city">
    <ModalComponentHeader>
      {{ messages.chooseCity }}
    </ModalComponentHeader>

    <ModalComponentBody>
      <DefInputSearch
        :placeholder="messages.placeholder"
        :header="userCity.UF_NAME"
        @input="handlerInput"
      >
        <div v-for="city in cities" @click="handlerSetCity(city.UF_NAME)">
          {{ city.UF_NAME }}
        </div>
      </DefInputSearch>

      <!--      <DefSelectSearch>-->
      <!--        <template #placeholder>-->
      <!--          {{ messages.placeholder }}-->
      <!--        </template>-->
      <!--              <template #header>-->
      <!--                {{ userCity.UF_NAME }}-->
      <!--              </template>-->
      <!--        <template #search>-->
      <!--          <input-->
      <!--            type="text"-->
      <!--            class="autofocus"-->
      <!--            :placeholder="messages.enterYourCity"-->
      <!--            @input="handlerInput"-->
      <!--          />-->
      <!--        </template>-->
      <!--        <div v-for="city in cities" @click="setCity(city.UF_NAME)">-->
      <!--          {{ city.UF_NAME }}-->
      <!--        </div>-->
      <!--      </DefSelectSearch>-->

      <div class="choice-city-list">
        <span
          v-for="city in citiesMenu"
          :key="city.name"
          class="choice-city-item"
          :class="{ 'choice-city-item_active': city.active }"
          @click="handlerSetCity(city.name)"
          >{{ city.name }}</span
        >
      </div>
    </ModalComponentBody>
  </div>
</template>

<script>
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import DefInputSearch from '@components/Def/DefInput/DefInputSearch.vue';
import useModal from '@use/useModal/useModal';
import { useCitiesStore } from '@/storePinia/stores/cities';

export default {
  name: 'ChoiceCity',
  components: { DefInputSearch, ModalComponentBody, ModalComponentHeader },
  data() {
    return {
      modal: useModal(),
      citiesStore: useCitiesStore(),
    };
  },
  computed: {
    citiesMenu() {
      return this.citiesStore.citiesMenu;
    },
    messages() {
      return this.citiesStore.messages;
    },
    userCity() {
      return this.citiesStore.userCity;
    },
    cities() {
      return this.citiesStore.cities;
    },
  },
  mounted() {
    this.citiesStore.getCities(this.userCity.UF_NAME);
  },
  mounted() {
    this.citiesStore.getCities(this.userCity.UF_NAME);
  },
  mounted() {
    this.citiesStore.getCities(this.userCity.UF_NAME);
  },
  methods: {
    handlerInput({ target: { value } }) {
      this.citiesStore.getCities(value);
    },
    async handlerSetCity(city) {
      await this.citiesStore.setCity(city);
      await this.citiesStore.getCities(city);
    },
  },
};
</script>

<style lang="scss" scoped>
.choice-city {
  min-height: 400px;
  @include point-md {
    font-size: rem(16);
  }
  &__title {
    margin-bottom: 24px;
    text-transform: uppercase;
  }
  :deep(.def-select-search) {
    margin-bottom: 24px;
  }
  :deep(.def-select-search__scroll) {
    max-height: 159px;
  }
}
.choice-city-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 16px;
  cursor: pointer;
  @include point-md {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.choice-city-item {
  transition: 0.2s linear color;
  color: var(--color-golden-browm);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  &_active {
    text-decoration: underline;
    text-underline-position: under;
  }
}
</style>
